import {
  DeliveryDetailsAction,
  useDeliveryDetailsContext,
} from '@buncha/driver/hooks/deliveryDetails';
import React, {useCallback} from 'react';
import {ScrollView, StyleSheet} from 'react-native';
import {
  useColorThemeType,
  useFontTheme,
} from '../../../../../src/appStyles/hooks/theme';

import {Box} from '@buncha/components/core/view';
import {H6Text} from '@buncha/components/core/text';
import {HomeScreens} from '@buncha/home/navigation/types';
import If from '@buncha/components/conditional/If';
import {Modules} from '@buncha/utils/types';
import {PTextInput} from '@buncha/components/core/input/TextInput';
import {WarningIcon} from 'native-base';
import {useGetLocale} from '@buncha/localization/hooks';

interface Props {
  isRequired: boolean;
  scrollViewRef: React.RefObject<ScrollView>;
}

const DriverDeliveryNotes: React.FC<Props> = props => {
  const theme = useColorThemeType('main');
  const muli = useFontTheme('muli');
  const {state, dispatch} = useDeliveryDetailsContext();
  const {title, body} = useGetLocale(Modules.driver, HomeScreens.Driver) ?? {};

  const handleScroll = useCallback(() => {
    setTimeout(() => {
      props.scrollViewRef.current?.scrollToEnd({animated: true});
    }, 100);
  }, [props.scrollViewRef]);

  const setDeliveryNotes = useCallback(
    (text: string) => {
      dispatch?.(DeliveryDetailsAction.setDeliveryNote(text));
    },
    [dispatch],
  );
  return (
    <Box style={styles.notesContainer}>
      <H6Text
        style={{
          color: theme?.text?.blue?.[300],
          fontFamily: muli?.[700]?.normal,
        }}>
        {title?.notes}
      </H6Text>
      <PTextInput
        onFocus={handleScroll}
        value={state.deliveryNote}
        numberOfLines={2}
        placeholder={body?.addNote}
        textAlignVertical={'top'}
        multiline={true}
        debounce={false}
        returnKeyType="done"
        style={[styles.input, {color: theme?.text?.blue?.[300]}]}
        onChangeText={setDeliveryNotes}
        containerStyle={[styles.inputContainer]}
        rightComponent={
          <If condition={props.isRequired}>
            <Box style={styles.warningIcon}>
              <WarningIcon
                style={styles.warningIcon}
                color={theme?.icon.red[100]}
              />
            </Box>
          </If>
        }
      />
    </Box>
  );
};

export default React.memo(DriverDeliveryNotes);

const styles = StyleSheet.create({
  touchable: {
    marginTop: 20,
    alignSelf: 'flex-start',
  },
  iconBox: {borderWidth: 1, justifyContent: 'flex-start'},
  icon: {
    marginRight: 10,
  },
  text: {
    textDecorationLine: 'underline',
  },
  notes: {
    gap: 5,
  },
  input: {
    height: 100,
    marginTop: 5,
  },
  inputContainer: {
    width: '100%',
    borderRadius: 15,
    marginTop: 10,
    borderWidth: 2,
    position: 'relative',
  },
  warningIcon: {
    position: 'absolute',
    right: 2,
    top: -45,
    alignSelf: 'flex-start',
    height: '100%',
  },
  notesContainer: {
    alignItems: 'flex-start',
    marginTop: 10,
    marginBottom: 50,
  },
});
